var _g, _g2, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRobotBroken(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 384,
    height: 386,
    viewBox: "0 0 384 386",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5527:17749)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.4652 156.088C69.0661 159.931 67.4472 164.339 66.8426 169.117C64.6385 186.73 77.1215 202.782 94.7343 204.986C112.347 207.19 128.399 194.707 130.603 177.095C131.208 172.336 130.72 167.693 129.355 163.402L114.024 161.608C116.911 165.45 118.374 170.366 117.73 175.495C116.423 185.989 106.847 193.42 96.3726 192.094C85.8986 190.767 78.4478 181.21 79.7742 170.736C80.4178 165.548 83.1095 161.101 86.9129 158.097L71.4652 156.088Z",
    stroke: "#F4323F",
    strokeWidth: 3.90094,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.01 202.197L115.039 211.891",
    stroke: "#F4323F",
    strokeWidth: 3.90094,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.8438 203.602C88.8438 203.602 88.4733 219.264 92.0426 225.35",
    stroke: "#F4323F",
    strokeWidth: 3.90094,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.324 278.246C321.106 275.067 317.166 272.511 312.621 270.873C295.925 264.846 277.513 273.506 271.505 290.202C265.478 306.898 274.138 325.311 290.834 331.318C295.34 332.937 299.982 333.503 304.468 333.113L309.617 318.523C305.248 320.493 300.119 320.844 295.242 319.089C285.295 315.5 280.146 304.538 283.735 294.591C287.323 284.643 298.285 279.494 308.233 283.083C313.148 284.858 316.912 288.447 318.999 292.816L324.324 278.246Z",
    stroke: "#F4323F",
    strokeWidth: 3.90094,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.145 304.246C269.145 304.246 258.047 298.375 242.833 311.56C242.833 311.56 231.755 312.067 229.59 301.067C227.425 290.066 237.996 284.858 237.996 284.858C237.996 284.858 252.683 272.239 275.348 282.303",
    stroke: "#F4323F",
    strokeWidth: 3.90094,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.159 303.271C259.159 303.271 246.383 291.977 259.471 278.383",
    stroke: "#F4323F",
    strokeWidth: 3.90094,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.055 306.527C249.055 306.527 233.803 298.96 240.824 283.473",
    stroke: "#F4323F",
    strokeWidth: 3.90094,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.482 200.461L48.3521 248.833L167.272 309.843L259.276 260.068L142.482 200.461Z",
    stroke: "#F4323F",
    strokeWidth: 7.80187,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.586 278.948L263.742 260.419",
    stroke: "#F4323F",
    strokeWidth: 7.80187,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.999 353.261L167.428 367.148L263.255 316.963L263.372 303.153",
    stroke: "#F4323F",
    strokeWidth: 7.80187,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4317 248.638V275.827",
    stroke: "#F4323F",
    strokeWidth: 7.80187,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.272 309.844V366.602",
    stroke: "#F4323F",
    strokeWidth: 7.80187,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.774 215.246L103.843 235.238L153.014 260.477L191.068 239.881L142.774 215.246Z",
    stroke: "#F4323F",
    strokeWidth: 3.90094,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.1983 255.678C102.182 253.179 105.98 248.631 104.681 245.519C103.381 242.408 97.4768 241.912 91.4926 244.411C85.5084 246.91 81.7106 251.459 83.0101 254.57C84.3095 257.681 90.2141 258.178 96.1983 255.678Z",
    stroke: "#F4323F",
    strokeWidth: 3.90094,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.393 265.022C124.377 262.522 128.174 257.974 126.875 254.863C125.576 251.751 119.671 251.255 113.687 253.754C107.703 256.253 103.905 260.802 105.204 263.913C106.504 267.025 112.408 267.521 118.393 265.022Z",
    stroke: "#F4323F",
    strokeWidth: 3.90094,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0602 348.105C34.7719 347.038 41.1763 332.806 39.3647 316.317C37.5532 299.827 28.2118 287.324 18.5001 288.391C8.78835 289.458 2.38399 303.691 4.19552 320.18C6.00705 336.67 15.3485 349.172 25.0602 348.105Z",
    stroke: "#F4323F",
    strokeWidth: 7.80187,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5737 288.525L57.8119 270.522C57.8119 270.522 79.4816 267.499 87.3225 290.066C92.7643 305.728 85.0209 319.576 85.0209 319.576L26.7604 347.546",
    stroke: "#F4323F",
    strokeWidth: 7.80187,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.2599 276.686C47.2599 276.686 79.5986 281.757 69.8658 326.988",
    stroke: "#F4323F",
    strokeWidth: 3.90094,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5533 283.219C32.5533 283.219 63.6633 292.036 53.4623 334.244",
    stroke: "#F4323F",
    strokeWidth: 3.90094,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.4183 381.267C96.13 380.2 102.534 365.967 100.723 349.478C98.9113 332.988 89.5699 320.486 79.8582 321.553C70.1465 322.619 63.7421 336.852 65.5537 353.341C67.3652 369.831 76.7066 382.333 86.4183 381.267Z",
    stroke: "#F4323F",
    strokeWidth: 7.80187,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9355 321.683L119.174 303.68C119.174 303.68 140.843 300.657 148.684 323.224C154.126 338.886 146.383 352.735 146.383 352.735L88.1417 380.704",
    stroke: "#F4323F",
    strokeWidth: 7.80187,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.622 309.864C108.622 309.864 140.96 314.935 131.228 360.166",
    stroke: "#F4323F",
    strokeWidth: 3.90094,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.9151 316.397C93.9151 316.397 125.025 325.213 114.824 367.421",
    stroke: "#F4323F",
    strokeWidth: 3.90094,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 205.5,
    cy: 196.749,
    r: 3.5,
    fill: "#F4323F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.333 204C234.934 205.018 233 207.188 233 209.767C233 213.82 237.951 214.307 241.025 214.013C242.328 213.888 245.953 213.852 246.341 212.11C246.517 211.322 246.489 210.127 245.819 209.607C244.987 208.961 243.5 208.5 242.389 209.127C241.718 208.845 240.65 210.062 240.222 210.488C239.649 211.061 239.552 212.087 238.958 212.811C238.386 213.51 238.232 214.436 238.437 215.355C238.812 217.04 238 218 239.139 220.221C239.152 220.44 240.665 221.116 241.025 221.222C242.383 221.624 243.794 221.698 245.218 221.643C247.533 221.552 248.731 222.02 251 221.643C251.404 221.576 253.298 220.757 253.583 220.401C254.468 219.298 253.849 217.442 252.941 216.536C252.481 216.076 249.5 215.355 247.826 216.456C245.819 218 247.444 219.346 247.444 220.942C247.444 222.18 246.722 223.199 246.722 224.366C246.722 225.276 248.121 225.975 248.528 226.89C249.543 229.171 253.621 228.512 255.59 228.512C256.906 228.512 258.128 228.613 258.5 227.5C259.5 226.5 259.092 223.529 258.679 223.485C257.5 222.5 256 222.5 253.944 223.465C253.091 223.515 253.019 226.902 252.941 227.39C252.688 228.99 252.017 230.702 252.901 232.357C254.215 234.815 256.461 235 259 235",
    stroke: "#F4323F",
    strokeWidth: 3,
    strokeLinecap: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_5527:17749)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M329.544 148.618L277.486 174.637L276.92 226.578L329.349 250.92L379.457 224.725L379.632 173.74L329.544 148.618Z",
    stroke: "#F4323F",
    strokeWidth: 7.80187,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.486 174.636L329.837 202.138L379.632 173.739",
    stroke: "#F4323F",
    strokeWidth: 7.80187,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.837 202.138V252.753",
    stroke: "#F4323F",
    strokeWidth: 7.80187,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.968 208.634L328.471 232.663",
    stroke: "#F4323F",
    strokeWidth: 3.90094,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.35 212.086V230.069",
    stroke: "#F4323F",
    strokeWidth: 3.90094,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.278 217.099V235.101",
    stroke: "#F4323F",
    strokeWidth: 3.90094,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.757 222.209V240.212",
    stroke: "#F4323F",
    strokeWidth: 3.90094,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.685 227.475V245.478",
    stroke: "#F4323F",
    strokeWidth: 3.90094,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.886 203.811C293.706 203.615 294.995 201.719 294.765 199.577C294.534 197.435 292.871 195.858 291.05 196.054C289.23 196.25 287.941 198.146 288.171 200.287C288.402 202.429 290.065 204.007 291.886 203.811Z",
    fill: "#F4323F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.64 215.125C317.461 214.929 318.75 213.034 318.519 210.892C318.288 208.75 316.625 207.172 314.805 207.369C312.984 207.565 311.695 209.46 311.926 211.602C312.157 213.744 313.82 215.321 315.64 215.125Z",
    fill: "#F4323F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 282.5,
    cy: 251.749,
    r: 3.5,
    fill: "#F4323F"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M259.276 2.01915C225.618 2.01915 194.631 0.73147 164.757 19.2741C158.874 22.9256 154.467 27.8517 149.035 32.1195C140.992 38.4392 155.449 37.498 160.347 38.2546C186.573 42.3058 213.077 46.2042 239.145 51.1958C245.654 52.4422 257.912 53.8986 263.11 58.5771C274.61 68.9276 247.363 85.2521 241.062 88.294C230.014 93.6276 216.345 96.831 206.744 104.686C203.988 106.941 190.516 123.884 194.665 126.255C200.028 129.32 221.216 134.981 215.275 140.922C212.651 143.546 206.222 154.081 209.236 155.588",
    stroke: "#BCBCBC",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5527:17749"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 326.586,
    height: 231.248,
    fill: "white",
    transform: "translate(0 154.001)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_5527:17749"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 110.533,
    height: 111.021,
    fill: "white",
    transform: "translate(273 144.249)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRobotBroken);
export default __webpack_public_path__ + "static/media/robot-broken.a6627337072afc57170f6b26d8ba3040.svg";
export { ForwardRef as ReactComponent };